import { render, staticRenderFns } from "./htmlTd.vue?vue&type=template&id=65648bd9&"
import script from "./htmlTd.vue?vue&type=script&lang=js&"
export * from "./htmlTd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports